import { Box, InputBase, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";
import Shbutton from "../../../../theme/buttons/Shbutton";
import SaveIcon from '@mui/icons-material/Save';
import Text from "../../../../theme/text/Text";
import Dropdown from "../../../../theme/dropout/DropOut";
import { useEffect, useState, useRef } from "react";
import ShValidatedInput from "../../../../theme/inputs/ShValidatedInput";
import CropFreeIcon from '@mui/icons-material/CropFree';
import ButtonGroup from "../../../../theme/buttons/ButtonGroup";
import { useDeleteWebshopCredentialsMutation, useEditWebshopCredentialsMutation, useSyncWebshopProductsMutation, useUploadWebshopLogoMutation, useGetObjectsQuery } from "../../../../../newapi/webshop/webshopSlice";
import FileUploadIcon from '@mui/icons-material/FileUpload';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import { showToastMessageDeleteRequest, showToastMessageRequestError, showToastMessageUpdateRequest, showToastMessageSyncProductsRequestError} from "../../../../../utils/toasts";
import DeleteIcon from '@mui/icons-material/Delete';
import MConfirmDelete from "../../../Modals/MConfirmDelete";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import cx from "classnames"
import { useGetRelationsSelectQuery } from "../../../../../newapi/global/relation/relationSlice";
import ShValidatedInputDropdown from "../../../../theme/dropdowns/ShValidatedInputDropdown";
import { useGetWarehousesSelectQuery } from "../../../../../newapi/warehouse/warehouseApiSlice";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import * as yup from "yup";
import { yupRequired } from "../../../../../utils/validation";
import EMGeneralExplainerBox from "../../../ModalsPopover/explainers/EMGeneralExplainerBox";
import SpDesktopFooter from "../../../../theme/sidepanel2/SidepanelFooter";
import AmazonOAuthButton from "../../../ModalsProgression/MpAddWebshop/components/AmazonOAuthButton";
import TikTokOAuthButton from "../../../ModalsProgression/MpAddWebshop/components/TikTokOAuthButton";
import { pickTikTokShop, buildTikTokCredentials } from "../../../ModalsProgression/MpAddWebshop/components/tiktokOauth";
import { config } from "../../../../../newapi/apiUrlConfig";
import { ENV_TYPES } from "../../../Sidebar";
import { general_states, kaufland_storefronts, mirakl_marketplaces, findMiraklMarketplaceIndex } from "../../../../../utils/staticEnums";
import { useGetSettingsForRelationQuery } from "../../../../../newapi/global/generalApiSlice";

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return props.hasModifyPermission ?
        <ButtonGroup version={2}>
            <Shbutton
                isLoading={props.isLoading}
                className={"group-btn"}
                onClick={props.deleteAction}
                color="red"
                variant="contained"
                    endIcon={<DeleteIcon />}
                >
                    {t('delete')}
                </Shbutton>
                <Shbutton
                    sx={{
                        marginLeft: 1
                    }}
                    isLoading={props.isLoading}
                    className={"group-btn"}
                    onClick={props.action}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained"
                    endIcon={<SaveIcon />}
                >
                    {t('save')}
            </Shbutton>
        </ButtonGroup> : <></>;
};

const getWebshopElements = (t, labelWidth) => ({
    woocommerce: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 216}}>
                <Text>{t("webshop_url")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 216}}>
                <Text>{t("webshop_consumer_key")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 216}}>
                <Text>{t("webshop_consumer_secret")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 216}}>
                <Text>{t("meta_pickup_carrier")}</Text>
                <EMGeneralExplainerBox title={t('meta_pickup_carrier')} text={t('em_meta_pickup_carrier_text')}></EMGeneralExplainerBox>
            </Box>
        </>
    ),
    kaufland: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("storefront")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("client_key")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("client_secret")}</Text>
            </Box>
        </>
    ),
    shopify: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("shop")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth, display: "flex", alignItems: "center"}}>
                <Text>{t("location")}</Text>
                <EMGeneralExplainerBox title={t('location')} text={t('em_shopify_location_text')}></EMGeneralExplainerBox>
            </Box>
            {/* <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 120}}>
                <Text>{t("client_key")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 120}}>
                <Text>{t("access_token")}</Text>
            </Box> */}
        </>
    ),
    amazon_stockhub: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 120}}>
                <Text>{t("marketplace")}</Text>
            </Box>
        </>
    ),
    bol: (credentialsInfo) => (
        <>
            {/* Hide client_id and client_secret for Bol SSO */}
            {!credentialsInfo?.credentials?.sso && (
                <>
                    <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                        <Text>{t("client_id")}</Text>
                    </Box>
                    <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                        <Text>{t("client_secret")}</Text>
                    </Box>
                </>
            )}
        </>
    ),
    ccvshop: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("webshop_url")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("api_secret")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("secret_key")}</Text>
            </Box>
        </>
    ),
    lightspeed: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("store_id")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("secret_token")}</Text>
            </Box>
        </>
    ),
    lightspeed_ecom: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("api_key")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("api_secret")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 184, display: "flex", alignItems: "center"}}>
                <Text>{t("dynamic_shipper")}</Text>
                <EMGeneralExplainerBox title={t('em_b2b_prefix_title')} text={t('em_lightspeed_dynamic_shipper_text')}></EMGeneralExplainerBox>
            </Box>
        </>
    ),
    magento: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("shop")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("access_token")}</Text>
            </Box>
        </>
    ),
    mirakl: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("marketplace")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("url")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("api_key")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("shop_id")}</Text>
            </Box>
        </>
    ),
    plugandpay: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("access_token")}</Text>
            </Box>
        </>
    ),
    shopware6: (
        <>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("webshop_url")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("client_id")}</Text>
            </Box>
            <Box lineHeight={"40px"} sx={{paddingTop: 2, width: labelWidth}}>
                <Text>{t("client_secret")}</Text>
            </Box>
        </>
    ),
});

const getWebshopInputFields = (colors, credentialsInfo, handleChange, shopifyLocations) => {
    const commonStyles = {
        display: "flex",
        height: "40px",
        borderRadius: "20px",
        backgroundColor: colors.grey[100],
        sx: {
            marginTop: 2,
            justifyContent: "space-between",
            "@media screen and (max-width: 47.9375em)": {
                flexDirection: "column"
            }
        }
    };

    const toggleStyles = {
        display: "flex",
        height: "40px",
        borderRadius: "20px",
        sx: {
            marginTop: 2,
            justifyContent: "space-between",
            "@media screen and (max-width: 47.9375em)": {
                flexDirection: "column"
            }
        }
    };

    const webshopConfigs = {
        woocommerce: [
            {
                value: credentialsInfo?.credentials?.url || "",
                onChange: (e) => handleChange('credentials.url', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.consumer_key || "",
                onChange: (e) => handleChange('credentials.consumer_key', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.consumer_secret || "",
                onChange: (e) => handleChange('credentials.consumer_secret', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.meta_pickup_carrier || "",
                onChange: (e) => handleChange('credentials.meta_pickup_carrier', e.target.value),
                styles: commonStyles
            }
        ],
        kaufland: [
            {
                value: credentialsInfo?.credentials?.storefront || "",
                onChange: (selected) => {
                    handleChange('credentials.storefront', kaufland_storefronts[selected].value);
                },
                styles: commonStyles,
                isDropdown: true,
                options: kaufland_storefronts
            },
            {
                value: credentialsInfo?.credentials?.client_key || "",
                onChange: (e) => handleChange('credentials.client_key', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.client_secret || "",
                onChange: (e) => handleChange('credentials.client_secret', e.target.value),
                styles: commonStyles
            }
        ],
        shopify: [
            {
                value: credentialsInfo?.credentials?.shop || "",
                onChange: (e) => handleChange('credentials.shop', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.location_id || "",
                onChange: (selected) => {
                    if (shopifyLocations && shopifyLocations[selected]) {
                        handleChange('credentials.location_id', shopifyLocations[selected].id);
                    }
                },
                styles: commonStyles,
                isDropdown: true,
                options: shopifyLocations || [],
                displayName: "name"
            },
        ],
        amazon_stockhub: [
            {
                value: credentialsInfo?.credentials?.marketplace || "NL",
                onChange: (selected) => {
                    const marketplaceOptions = [
                        { value: 'NL', label: 'Netherlands (NL)' },
                        { value: 'BE', label: 'Belgium (BE)' },
                        { value: 'DE', label: 'Germany (DE)' },
                        { value: 'FR', label: 'France (FR)' },
                        { value: 'IT', label: 'Italy (IT)' },
                        { value: 'ES', label: 'Spain (ES)' },
                        { value: 'UK', label: 'United Kingdom (UK)' },
                        { value: 'SE', label: 'Sweden (SE)' },
                        { value: 'PL', label: 'Poland (PL)' },
                        { value: 'IE', label: 'Ireland (IE)' }
                    ];
                    handleChange('credentials.marketplace', marketplaceOptions[selected].value);
                },
                styles: commonStyles,
                isDropdown: true,
                options: [
                    { value: 'NL', label: 'Netherlands (NL)' },
                    { value: 'BE', label: 'Belgium (BE)' },
                    { value: 'DE', label: 'Germany (DE)' },
                    { value: 'FR', label: 'France (FR)' },
                    { value: 'IT', label: 'Italy (IT)' },
                    { value: 'ES', label: 'Spain (ES)' },
                    { value: 'UK', label: 'United Kingdom (UK)' },
                    { value: 'SE', label: 'Sweden (SE)' },
                    { value: 'PL', label: 'Poland (PL)' },
                    { value: 'IE', label: 'Ireland (IE)' }
                ]
            }
        ],
        bol: [
            // Hide client_id and client_secret for Bol SSO
            ...(credentialsInfo?.credentials?.sso ? [] : [
                {
                    value: credentialsInfo?.credentials?.client_id || "",
                    onChange: (e) => handleChange('credentials.client_id', e.target.value),
                    styles: commonStyles
                },
                {
                    value: credentialsInfo?.credentials?.client_secret || "",
                    onChange: (e) => handleChange('credentials.client_secret', e.target.value),
                    styles: commonStyles
                },
            ]),
        ],
        ccvshop: [
            {
                value: credentialsInfo?.credentials?.url || "",
                onChange: (e) => handleChange('credentials.url', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.public_key || "",
                onChange: (e) => handleChange('credentials.public_key', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.secret_key || "",
                onChange: (e) => handleChange('credentials.secret_key', e.target.value),
                styles: commonStyles
            }
        ],
        lightspeed: [
            {
                value: credentialsInfo?.credentials?.store_id || "",
                onChange: (e) => handleChange('credentials.store_id', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.secret_token || "",
                onChange: (e) => handleChange('credentials.secret_token', e.target.value),
                styles: commonStyles
            }
        ],
        lightspeed_ecom: [
            {
                value: credentialsInfo?.credentials?.api_key || "",
                onChange: (e) => handleChange('credentials.api_key', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.api_secret || "",
                onChange: (e) => handleChange('credentials.api_secret', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.dynamic_shipper || "",
                onChange: (e, value) => handleChange('credentials.dynamic_shipper', value === "true"),
                styles: toggleStyles,
                isToggleButton: true
            }
        ],
        magento: [
            {
                value: credentialsInfo?.credentials?.shop || "",
                onChange: (e) => handleChange('credentials.shop', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.access_token || "",
                onChange: (e) => handleChange('credentials.access_token', e.target.value),
                styles: commonStyles
            },
        ],
        mirakl: [
            {
                // Selecting a marketplace overwrites the url below with its API base URL
                value: mirakl_marketplaces[findMiraklMarketplaceIndex(credentialsInfo?.credentials?.url)]?.value || "",
                onChange: (selected) => {
                    handleChange('credentials.url', mirakl_marketplaces[selected].value);
                },
                styles: commonStyles,
                isDropdown: true,
                options: mirakl_marketplaces
            },
            {
                value: credentialsInfo?.credentials?.url || "",
                onChange: (e) => handleChange('credentials.url', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.api_key || "",
                onChange: (e) => handleChange('credentials.api_key', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.shop_id || "",
                onChange: (e) => handleChange('credentials.shop_id', e.target.value),
                styles: commonStyles
            }
        ],
        plugandpay: [
            {
                value: credentialsInfo?.credentials?.access_token || "",
                onChange: (e) => handleChange('credentials.access_token', e.target.value),
                styles: commonStyles
            }
        ],
        shopware6: [
            {
                value: credentialsInfo?.credentials?.url || "",
                onChange: (e) => handleChange('credentials.url', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.client_id || "",
                onChange: (e) => handleChange('credentials.client_id', e.target.value),
                styles: commonStyles
            },
            {
                value: credentialsInfo?.credentials?.client_secret || "",
                onChange: (e) => handleChange('credentials.client_secret', e.target.value),
                styles: commonStyles
            }
        ],
    };

    return webshopConfigs[credentialsInfo?.webshop_type] || [];
};

const DetailsPanel = (props) => {
    const  { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [open, setOpen] = useState(false);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const { data: warehouses } = useGetWarehousesSelectQuery();
    const hasModifyPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WEBSHOPCREDENTIALS_MANAGE, UserPrivileges.RP_WEBSHOPCREDENTIALS_MANAGE, UserPrivileges.SETTINGS_ALL])
    );
    
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];
    // A relation only sees the packing slip switch when the warehouse allows it (relation_edit_pickingslip)
    const { data: relationSettings } = useGetSettingsForRelationQuery(undefined, { skip: !isRelation });
    const canEditPickingslip = !isRelation || relationSettings?.find(setting => setting.key === "relation_edit_pickingslip")?.value === "true";

    // Fetch relations using the useGetRelationsQuery hook
    const { data: relationsData, isLoading: relationsLoading } = useGetRelationsSelectQuery();

    const [credentialsInfo, setCredentialsInfo] = useState({
      id: 0,
      dimensions: null,
      webshopcredentials: null,
      webshop_type: "",
      description: "",
      token: "",
      syncProducts: false,
      syncStock: false,
      syncOrders: false,
      syncCreateProducts: false,
      warehouseId: null,
      shippingName: "",
      includeReturnLabel: false
    });

    const [credentialsArray, setCredentialsArray] = useState([{key: "", credentials: {}}]);

    // Fetch Shopify locations only if webshop_type is shopify
    const { data: shopifyLocationsData } = useGetObjectsQuery(
        { type: 'shopifylocations', id: credentialsInfo?.id },
        { skip: credentialsInfo?.webshop_type !== 'shopify' || !credentialsInfo?.id }
    );

    const [shopifyLocations, setShopifyLocations] = useState([]);

    useEffect(() => {
        if (shopifyLocationsData?.success) {
            const mappedData = shopifyLocationsData.locations.map(x => {
                return {
                    id: x.id.toString(),
                    name: `${x.name} - ${x.address1} - ${x.city}`
                }
            })
            setShopifyLocations([{id: null, name: t('none')}, ...mappedData]);
        }

    }, [shopifyLocationsData])

   // const { data: shippers } = useGetShippersSelectQuery();

    // Logo upload state
    const logoFileInputRef = useRef(null);
    const [isUploadingLogo, setIsUploadingLogo] = useState(false);
    const [uploadLogoMutation] = useUploadWebshopLogoMutation();

    useEffect(() => {
        setCredentialsInfo(props.data);

        if (props.data?.credentials) {
            setCredentialsArray([{key: props.data.webshop_type, credentials: props.data.credentials}]);
        }
    },[props.data]);

    const handleChange = (key, value) => {
        setCredentialsInfo(credentialsInfo => {
            // Update credentialsInfo as before
            const updatedCredentialsInfo = { ...credentialsInfo };
            const keys = key.split('.');
    
            if (keys.length === 2) {
                // Assuming keys[0] is 'credentials', update nested property
                updatedCredentialsInfo[keys[0]] = {
                    ...updatedCredentialsInfo[keys[0]],
                    [keys[1]]: value
                };
            } else if (keys.length === 3) {
                updatedCredentialsInfo[keys[0]] = {
                    ...updatedCredentialsInfo[keys[0]],
                    [keys[1]]: {
                        ...updatedCredentialsInfo[keys[0]][keys[1]],
                        [keys[2]]: value
                    }
                };
            } else {
                let credentials = updatedCredentialsInfo.credentials;
                if (key === "webshop_type") {
                    credentials = getCredentialsFromWebshopType(value);
                }
                updatedCredentialsInfo[key] = value;
                updatedCredentialsInfo["credentials"] = credentials;
            }
    
            if (keys.length > 1 && keys[0] === "credentials") {
                // Update credentialsArray
                setCredentialsArray(credentialsArray => {
                    const index = credentialsArray.findIndex(item => item.key === updatedCredentialsInfo.webshop_type);
                    let updatedCredentialsArray = [...credentialsArray];
        
                    if (index !== -1) {
                        // Update existing item
                        updatedCredentialsArray[index] = {
                            ...updatedCredentialsArray[index],
                            credentials: updatedCredentialsInfo.credentials
                        };
                    } else {
                        // Add new item if not found
                        updatedCredentialsArray.push({
                            key: updatedCredentialsInfo.webshop_type,
                            credentials: updatedCredentialsInfo.credentials
                        });
                    }
        
                    return updatedCredentialsArray;
                });
            }
    
            return updatedCredentialsInfo;
        });
    };

    const webshopTypes = [
        {value: "woocommerce", name: "Woocommerce"},
        {value: "shopify", name: "Shopify"},
        {value: "bol", name: "Bol."},
        {value: "ccvshop", name: "CCV Shop"},
        {value: "kaufland", name: "Kaufland"},
        {value: "lightspeed", name: "Lightspeed"},
        {value: "magento", name: "Magento"},
        {value: "mirakl", name: "Mirakl"},
        {value: "plugandpay", name: "Plug&Pay"},
        {value: "shopware6", name: "Shopware"},
    ];

    const dimensionUnits = [
        {value: "cm", name: "cm"},
        {value: "mm", name: "mm"},
    ];

    const weightUnits = [
        {value: "kg", name: "kg"},
        {value: "gram", name: "gram"},
    ];

    const inputFields = getWebshopInputFields(colors, credentialsInfo, handleChange, shopifyLocations);
    const webshopElements = getWebshopElements(t, 140);

    const renderWebshopSpecificElements = (webshopType) => {
        const element = webshopElements[webshopType];
        // Handle function-based elements (like bol which needs credentialsInfo)
        if (typeof element === 'function') {
            return element(credentialsInfo);
        }
        return element || null;
    };

    const getCredentialsFromWebshopType = (webshopType) => {
        let webshopCredentialsObject = credentialsArray.find(c => c.key === webshopType);
        if (webshopCredentialsObject) { 
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "woocommerce") {
            webshopCredentialsObject = {key: "woocommerce", credentials: {
                url: "",
                consumer_key: "",
                consumer_secret: "",
                meta_pickup_carrier: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "shopify") {
            webshopCredentialsObject = {key: "shopify", credentials: {
                shop: "",
                client_key: "",
                access_token: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "amazon_stockhub") {
            webshopCredentialsObject = {key: "amazon_stockhub", credentials: {
                refresh_token: "",
                selling_partner_id: "",
                marketplace: "NL",
                marketplace_id: "A1805IZSGTT6HS",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "tiktokshop") {
            webshopCredentialsObject = {key: "tiktokshop", credentials: {
                access_token: "",
                refresh_token: "",
                expiresAt: "",
                shop_cipher: "",
                shop_id: "",
                seller_name: "",
                region: "global",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "bol") {
            webshopCredentialsObject = {key: "bol", credentials: {
                client_id: "",
                client_secret: "",
                vvb_bool: false,
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "ccvshop") {
            webshopCredentialsObject = {key: "ccvshop", credentials: {
                url: "",
                public_key: "",
                secret_key: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};
        } else if (webshopType === "kaufland") {
            webshopCredentialsObject = {key: "kaufland", credentials: {
                storefront: "",
                client_key: "",
                client_secret: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "lightspeed") {
            webshopCredentialsObject = {key: "lightspeed", credentials: {
                store_id: "",
                secret_token: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};

            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        } else if (webshopType === "magento") {
            webshopCredentialsObject = {key: "magento", credentials: {
                shop: "",
                access_token: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};
        } else if (webshopType === "mirakl") {
            webshopCredentialsObject = {key: "mirakl", credentials: {
                url: "",
                api_key: "",
                shop_id: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};
        } else if (webshopType === "plugandpay") {
            webshopCredentialsObject = {key: "plugandpay", credentials: {
                access_token: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};
        } else if (webshopType === "shopware6") {
            webshopCredentialsObject = {key: "shopware6", credentials: {
                url: "",
                client_id: "",
                client_secret: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};
        } else if (webshopType === "boombabamboo") {
            webshopCredentialsObject = {key: "boombabamboo", credentials: {
                apiKey: "",
                measuring_units: { weight: "gram", dimensions: "cm"}
            }};
        }

        if (webshopCredentialsObject) {
            credentialsArray.push(webshopCredentialsObject);
            return webshopCredentialsObject.credentials;
        }
    }

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        description: yupRequired('description', t)
    };
    
    const schema = yup.object().shape(rules);
    
    const [EditWebshopCredentials,{isLoading}] = useEditWebshopCredentialsMutation();
    const handleSaveClick = async () => {
        try {
            if (isLoading) return;

            setFieldErrors({});
            await schema.validate(credentialsInfo, { abortEarly: false });
            const { state, ...credentialsWithoutState } = credentialsInfo;
            const response = await EditWebshopCredentials(credentialsWithoutState).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});
          
                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("update_failed"), t, err);
              }
        }
    };

    // Persist the Amazon OAuth result immediately, so the refresh_token and
    // selling_partner_id are not lost if the panel is closed without a manual save.
    const handleAmazonOAuthSuccess = async ({ refresh_token, selling_partner_id }) => {
        const updatedCredentialsInfo = {
            ...credentialsInfo,
            credentials: {
                ...credentialsInfo.credentials,
                refresh_token,
                selling_partner_id,
            },
        };
        setCredentialsInfo(updatedCredentialsInfo);
        try {
            const { state, ...credentialsWithoutState } = updatedCredentialsInfo;
            const response = await EditWebshopCredentials(credentialsWithoutState).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t("update_failed"), t, err);
        }
    };

    // Persist the TikTok OAuth result immediately, so the rotated tokens are not
    // lost if the panel is closed without a manual save. On reconnect the shop
    // matching the stored shop_id is kept; a payload without it is rejected.
    const handleTikTokOAuthSuccess = async (payload) => {
        const shop = pickTikTokShop(payload?.shops, credentialsInfo?.credentials?.shop_id);
        const tiktokCredentials = buildTikTokCredentials(payload, shop);
        if (!tiktokCredentials) {
            showToastMessageRequestError(t('tiktok_connection_failed'), t, {});
            return;
        }
        const updatedCredentialsInfo = {
            ...credentialsInfo,
            credentials: {
                ...credentialsInfo.credentials,
                ...tiktokCredentials,
            },
        };
        setCredentialsInfo(updatedCredentialsInfo);
        try {
            const { state, ...credentialsWithoutState } = updatedCredentialsInfo;
            const response = await EditWebshopCredentials(credentialsWithoutState).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t("update_failed"), t, err);
        }
    };

    const [SyncWebshopProducts,{syncIsLoading}] = useSyncWebshopProductsMutation();
    const handleSyncClick = async () => {
        try {
            const response = await SyncWebshopProducts({id: credentialsInfo?.id}).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            showToastMessageSyncProductsRequestError(t, err);
        }
    };
    // Logo upload handlers
    const handleLogoUploadClick = () => {
        if (logoFileInputRef.current) {
            logoFileInputRef.current.click();
        }
    };

    const handleLogoFileChange = async (event) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setIsUploadingLogo(true);

            try {
                const response = await uploadLogoMutation({
                    id: credentialsInfo.id,
                    file: file
                }).unwrap();
                showToastMessageUpdateRequest(t, response);
            } catch (error) {
                console.error('Error uploading logo:', error);
                showToastMessageRequestError(t('logo_upload_failed'), t, error);
            } finally {
                setIsUploadingLogo(false);
                // Reset file input
                if (logoFileInputRef.current) {
                    logoFileInputRef.current.value = '';
                }
            }
        }
    };

    const [DeleteWebshopCredentialsMutation] = useDeleteWebshopCredentialsMutation();
    const handleDeleteClick = async () => {
      setOpen(true);
    };
    const confirmDelete = async () => {
        try {
            const response = await DeleteWebshopCredentialsMutation(props.data.id).unwrap();
            showToastMessageDeleteRequest(t, response);
            props.setIsExtended(false);
        } catch (err) {
            showToastMessageDeleteRequest(t, {success: false, error: err.error});
        }
    };

    const confirmDeleteModal = {
        data: credentialsInfo?.description,
        open: open,
        setOpen: setOpen,
        confirm: confirmDelete
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            mobileActions:<GridActions 
                hasModifyPermission={hasModifyPermission}
                isLoading={isLoading}
                id={credentialsInfo?.id}
                action={handleSaveClick}
                syncAction={handleSyncClick}></GridActions>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[credentialsInfo,handleSaveClick,handleSyncClick]);

    return (
            <Box height={1} display={"flex"} flexDirection={"column"} paddingX={3}
                sx={{
                    "@media screen and (min-width: 48.1em)"  :{
                        marginBottom:11
                    }
                }}
            >
                {isRelation && credentialsInfo?.state === general_states.CONCEPT && (
                <Box
                    sx={{
                        background: colors.orange[100],
                        py: 1,
                        px: 2,
                        borderRadius: 2,
                        mt:2,
                        border: `1px solid ${colors.orange[400]}`,
                    }}
                >
                    <Text bold>{t("sales_channel_activation_pending")}</Text>
                    <Text>{t("sales_channel_activation_pending_text")}</Text>
                </Box>
                )}
                <Dropdown title={t("webshop")} open>
                    
                { isFulfilment ? 
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 4,
                        justifyContent:"flex-start",
                        marginBottom: 3
                    }}
                >
                    <Box
                        sx={{
                            "@media screen and (max-width: 47.9375em)" : {
                                flex:1
                            },
                            width: credentialsInfo?.webshop_type === "bol" ? 210 : 184
                        }}
                    >
                        <Text semiBold>
                            {t('relation')}
                        </Text>
                    </Box>
                    <Box flex={6}>
                        <ShValidatedInputDropdown
                            closeOnSelection
                            searchOptions={{
                                enabled: true,
                                placeholder: t("search_relation_placeholder")
                            }}
                            name="relationId"
                            displayName="name"
                            changeField="id"
                            selected={relationsData?.findIndex(relation => relation.id === credentialsInfo?.relationId) ?? 0}
                            noSelection={t("choose_relation")} //Custom text when nothing is selected
                            options={relationsData ?? []}
                            onChange={handleChange}
                        />
                    </Box>
                </Box> : <></>}
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 4,
                        justifyContent:"flex-start",
                        marginBottom: 2
                    }}
                >
                    <Box
                        sx={{
                            "@media screen and (max-width: 47.9375em)" : {
                                flex:1
                            },
                            width: 184
                        }}
                    >
                        <Text semiBold>
                            {t('description')}
                        </Text>
                    </Box>
                    <Box flex={6}>
                    <ShValidatedInput
                            name="description"
                            value={credentialsInfo?.description ?? ""}
                            onChange={handleChange}
                            error={fieldErrors.description}
                        />
                    </Box>
                </Box>
                <Box flex={1}
                    sx={{
                        display:"flex",
                        gap: 4,
                        justifyContent:"flex-start"
                    }}
                >
                    <Box
                        sx={{
                            "@media screen and (max-width: 47.9375em)" : {
                                flex:1
                            },
                            width: 184,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Text semiBold>
                            {t('shipping_name')}
                        </Text>
                        <EMGeneralExplainerBox
                            title={t('shipping_name')}
                            text={t('em_shippingname_text')}
                        />
                    </Box>
                    <Box flex={6}>
                    <ShValidatedInput
                            name="shippingName"
                            value={credentialsInfo?.shippingName ?? ""}
                            onChange={handleChange}
                            error={fieldErrors.shippingName}
                        />
                    </Box>
                </Box>

                {credentialsInfo?.webshop_type === 'amazon_stockhub' && (
                    <Box sx={{ width: 1, mt: 2, mb: 2 }}>
                        <AmazonOAuthButton
                            oauthUrl={`${config.url.API_BACKEND_URL}oauth/amazon/start`}
                            backendOrigin={new URL(config.url.API_BACKEND_URL).origin}
                            onSuccess={handleAmazonOAuthSuccess}
                            onError={() => {}}
                            isAuthenticated={!!credentialsInfo?.credentials?.refresh_token}
                            onDisconnect={() => {
                                handleChange('credentials.refresh_token', '');
                                handleChange('credentials.selling_partner_id', '');
                                handleChange('credentials.marketplace', '');
                                handleChange('credentials.marketplace_id', '');
                            }}
                        />
                    </Box>
                )}

                {credentialsInfo?.webshop_type === 'tiktokshop' && (
                    <Box sx={{ width: 1, mt: 2, mb: 2 }}>
                        <TikTokOAuthButton
                            oauthUrl={`${config.url.API_BACKEND_URL}oauth/tiktok/start`}
                            backendOrigin={new URL(config.url.API_BACKEND_URL).origin}
                            region={credentialsInfo?.credentials?.region || 'global'}
                            onSuccess={handleTikTokOAuthSuccess}
                            onError={() => {}}
                            isAuthenticated={!!credentialsInfo?.credentials?.access_token}
                            onDisconnect={() => {
                                handleChange('credentials.access_token', '');
                                handleChange('credentials.refresh_token', '');
                                handleChange('credentials.expiresAt', '');
                                handleChange('credentials.shop_cipher', '');
                                handleChange('credentials.shop_id', '');
                                handleChange('credentials.seller_name', '');
                            }}
                        />
                        {credentialsInfo?.credentials?.seller_name && (
                            <Box sx={{ mt: 1 }}>
                                <Text light>
                                    {`${t('seller_name')}: ${credentialsInfo.credentials.seller_name}`}
                                    {credentialsInfo.credentials.shop_id ? ` — ${t('shop_id')}: ${credentialsInfo.credentials.shop_id}` : ''}
                                </Text>
                            </Box>
                        )}
                    </Box>
                )}

                    <Box sx={{
                        display:"flex",
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            flexDirection:"column"
                        }
                    }}>
                        
                        {/* Two columns */}
                        
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start"
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    }
                                }}
                            >
                                {renderWebshopSpecificElements(credentialsInfo?.webshop_type)}
                                {!isRelation && (
                                <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 184}}>
                                    <Text>{t("warehouse")}</Text>
                                </Box>
                                )}
                                {typeof credentialsInfo?.dropshipOrders !== "undefined" && (
                                <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 184, display: "flex", alignItems: "center"}}>
                                    <Text>{t("dropship_orders")}</Text>
                                    <EMGeneralExplainerBox
                                        title={t('em_dropship_orders_title')}
                                        text={t('em_dropship_orders_text')}
                                    />
                                </Box>
                                )}
                                {!isRelation && (
                                <Box lineHeight={"40px"} sx={{paddingTop: 2, width: 184, display: "flex", alignItems: "center"}}>
                                    <Text>{t("include_returnlabel")}</Text>
                                    <EMGeneralExplainerBox
                                        title={t('include_returnlabel')}
                                        text={t('em_include_returnlabel_text')}
                                    />
                                </Box>
                                )}
                            </Box>
                            <Box flex={6}>
                            {inputFields.map((field, index) => (
                                <Box key={index} {...field.styles}>
                                    {field.isToggleButton ? (
                                        <ToggleButtonGroup
                                            color={field.value === true ? "green" : "red"}
                                            value={field.value ? "true" : "false"}
                                            exclusive
                                            onChange={(e, value) => field.onChange(field.key, value)}
                                            aria-label="Active"
                                            className={cx(`${field.value}`, {
                                                'active': field.value === true
                                            })}
                                            sx={{
                                                background: colors.red[100],
                                                padding: 0.5,
                                                borderRadius: 5,
                                                transition: "250ms",
                                                "&.active": {
                                                    background: colors.green[100],
                                                    transition: "250ms",
                                                },
                                            }}
                                        >
                                            <ToggleButton
                                                sx={{
                                                    padding: 0,
                                                    paddingX: 2,
                                                    border: 0,
                                                    lineHeight: "32px",
                                                    textTransform: "unset",
                                                    borderRadius: "32px !important",
                                                    color: colors.green[400],
                                                    transition: "250ms",
                                                    "&.Mui-selected,&.Mui-selected:hover": {
                                                        background: colors.red[400],
                                                        color: `${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                                    }
                                                }}
                                                value="false"
                                            >
                                                {t('inactive')}
                                            </ToggleButton>
                                            <ToggleButton
                                                sx={{
                                                    padding: 0,
                                                    paddingX: 2,
                                                    border: 0,
                                                    lineHeight: "32px",
                                                    textTransform: "unset",
                                                    borderRadius: "32px !important",
                                                    color: colors.red[400],
                                                    transition: "250ms",
                                                    "&.Mui-selected,&.Mui-selected:hover": {
                                                        background: colors.green[400],
                                                        color: `${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                                    }
                                                }}
                                                value="true"
                                            >
                                                {t('active')}
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    ) : field.isDropdown ? (
                                        <InputDropdown
                                            sx={{ ml: 2, flex: 1 }}
                                            displayName={field.displayName || "label"}
                                            noSelection={t('choose_option')}
                                            options={field.options || []}
                                            selected={Array.isArray(field.options) ? field.options.findIndex(opt =>
                                                field.displayName === "name"
                                                    ? opt.id === field.value
                                                    : opt.value === field.value
                                            ) : -1}
                                            onChange={field.onChange}
                                            closeOnSelection
                                        />
                                    ) : (
                                        <InputBase
                                            sx={{ ml: 2, flex: 1 }}
                                            value={field.value}
                                            onChange={field.onChange}
                                        />
                                    )}
                                </Box>
                            ))}
                            {!isRelation && (
                            <Box sx={{
                                display: "flex",
                                height: "40px",
                                borderRadius: "20px",
                                backgroundColor: colors.grey[100],
                                marginTop: 2,
                                justifyContent: "space-between",
                                "@media screen and (max-width: 47.9375em)": {
                                    flexDirection: "column"
                                }
                            }}>
                                <InputDropdown sx={{ ml: 2, flex: 1 }}
                                    displayName={"name"} 
                                    onChange={(selected) => handleChange('warehouseId', warehouses?.data[selected]?.id)}
                                    noSelection={t("choose_warehouse")} //Custom text when nothing is selected
                                    options={warehouses?.data ?? []}
                                    selected={warehouses?.data?.findIndex(warehouse => warehouse.id === credentialsInfo?.warehouseId) ?? -1}
                                    closeOnSelection
                                />
                            </Box>
                            )}
                            {typeof credentialsInfo?.dropshipOrders !== "undefined" && (
                            <Box sx={{
                                display: "flex",
                                height: "40px",
                                borderRadius: "20px",
                                marginTop: 2,
                                justifyContent: "space-between",
                                "@media screen and (max-width: 47.9375em)": {
                                    flexDirection: "column"
                                }
                            }}>
                                <ToggleButtonGroup
                                    color={credentialsInfo.dropshipOrders ? "green" : "red"}
                                    value={credentialsInfo.dropshipOrders ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("dropshipOrders", e.target.value === "true" ? true : false)}
                                    aria-label="Active"
                                    className={cx(`${credentialsInfo.dropshipOrders}`, {
                                        'active': credentialsInfo.dropshipOrders
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton 
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton 
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                            )}
                            {!isRelation && (
                            <Box sx={{
                                display: "flex",
                                height: "40px",
                                borderRadius: "20px",
                                marginTop: 2,
                                justifyContent: "space-between",
                                "@media screen and (max-width: 47.9375em)": {
                                    flexDirection: "column"
                                }
                            }}>
                                <ToggleButtonGroup
                                    color={credentialsInfo?.includeReturnLabel ? "green" : "red"}
                                    value={credentialsInfo?.includeReturnLabel ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("includeReturnLabel", e.target.value === "true" ? true : false)}
                                    aria-label="Active"
                                    className={cx(`${credentialsInfo?.includeReturnLabel}`, {
                                        'active': credentialsInfo?.includeReturnLabel
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton 
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton 
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Dropdown>

                {(canEditPickingslip || credentialsInfo?.pickingslipEnabled || credentialsInfo?.credentials?.addPickingSlipToTrackingMail) && (
                <Dropdown title={t("pickingslip_settings")} open>
                    {canEditPickingslip && (
                    <Box sx={{
                        display:"flex",
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            flexDirection:"column"
                        }
                    }}>
                        {/* Enable Pickingslip Toggle */}
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginBottom: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140
                                }}
                            >
                                <Text semiBold>{t("enable_pickingslip")}</Text>
                            </Box>
                            <Box flex={6}>
                                <ToggleButtonGroup
                                    color={credentialsInfo?.pickingslipEnabled ? "green" : "red"}
                                    value={credentialsInfo?.pickingslipEnabled ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("pickingslipEnabled", value === "true" ? true : false)}
                                    aria-label="Enable Pickingslip"
                                    className={cx(`${credentialsInfo?.pickingslipEnabled}`, {
                                        'active': credentialsInfo?.pickingslipEnabled
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>
                    </Box>
                    )}

                    {/* Logo Upload Section - Only show if pickingslip is enabled */}
                    {(credentialsInfo?.pickingslipEnabled || credentialsInfo?.credentials?.addPickingSlipToTrackingMail) && (
                        <>
                        <Box sx={{
                            display:"flex",
                            justifyContent:"space-between",
                            marginTop: 2,
                            "@media screen and (max-width: 47.9375em)" : {
                                flexDirection:"column"
                            }
                        }}>
                            <Box flex={1}
                                sx={{
                                    display:"flex",
                                    gap: 4,
                                    justifyContent:"flex-start"
                                }}
                            >
                                <Box
                                    sx={{
                                        "@media screen and (max-width: 47.9375em)" : {
                                            flex:1
                                        },
                                        width: 140
                                    }}
                                >
                                    <Text semiBold>{t("pickingslip_logo")}</Text>
                                </Box>
                                <Box flex={6}>
                                    {/* Hidden file input */}
                                    <input
                                        type="file"
                                        ref={logoFileInputRef}
                                        style={{ display: 'none' }}
                                        onChange={handleLogoFileChange}
                                        accept="image/*"
                                    />

                                    {/* Show current logo if exists */}
                                    {credentialsInfo?.logoUrl && !isUploadingLogo && (
                                        <Box sx={{
                                            marginBottom: 2,
                                            padding: 2,
                                            borderRadius: 4,
                                            background: colors.grey[100],
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 2
                                        }}>
                                            <img
                                                src={credentialsInfo.logoUrl}
                                                alt="Pickingslip Logo"
                                                style={{
                                                    maxHeight: '60px',
                                                    maxWidth: '200px',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                            <Text light size="fs12">{t("current_logo")}</Text>
                                        </Box>
                                    )}

                                    {/* Upload Status */}
                                    {isUploadingLogo && (
                                        <Box sx={{
                                            background: colors.blue[100],
                                            color: colors.blue[400],
                                            padding: 2,
                                            marginBottom: 2,
                                            borderRadius: 4,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 2
                                        }}>
                                            <CircularProgress size={24} />
                                            <Text bold>{t("uploading_logo")}</Text>
                                        </Box>
                                    )}

                                    {/* Upload Button */}
                                    <Shbutton
                                        onClick={handleLogoUploadClick}
                                        color="primary"
                                        variant="text"
                                        startIcon={<FileUploadIcon/>}
                                        disabled={isUploadingLogo}
                                    >
                                        {credentialsInfo?.logoUrl ? t("replace_logo") : t("upload_logo")}
                                    </Shbutton>
                                </Box>
                            </Box>
                        </Box>

                        {/* Return QR Toggle */}
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginTop: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140
                                }}
                            >
                                <Text semiBold>{t("pickingslip_return_qr")}</Text>
                            </Box>
                            <Box flex={6}>
                                <ToggleButtonGroup
                                    color={credentialsInfo?.pickingslipReturnQR ? "green" : "red"}
                                    value={credentialsInfo?.pickingslipReturnQR ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("pickingslipReturnQR", value === "true" ? true : false)}
                                    aria-label="Return QR"
                                    className={cx(`${credentialsInfo?.pickingslipReturnQR}`, {
                                        'active': credentialsInfo?.pickingslipReturnQR
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>

                        {/* Pakbon per doos Toggle */}
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginTop: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140
                                }}
                            >
                                <Text semiBold>{t("pickingslip_per_carrier")}</Text>
                            </Box>
                            <Box flex={6}>
                                <ToggleButtonGroup
                                    color={credentialsInfo?.pickingslipPerCarrier ? "green" : "red"}
                                    value={credentialsInfo?.pickingslipPerCarrier ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("pickingslipPerCarrier", value === "true" ? true : false)}
                                    aria-label="Pickingslip per carrier"
                                    className={cx(`${credentialsInfo?.pickingslipPerCarrier}`, {
                                        'active': credentialsInfo?.pickingslipPerCarrier
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>

                        {/* Opmerking tonen Toggle */}
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginTop: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140,
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <Text semiBold>{t("pickingslip_show_remark")}</Text>
                                <EMGeneralExplainerBox
                                    title={t('em_pickingslip_show_remark_title')}
                                    text={t('em_pickingslip_show_remark_text')}
                                />
                            </Box>
                            <Box flex={6}>
                                <ToggleButtonGroup
                                    color={credentialsInfo?.pickingslipShowRemark ? "green" : "red"}
                                    value={credentialsInfo?.pickingslipShowRemark ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("pickingslipShowRemark", value === "true" ? true : false)}
                                    aria-label="Show remark"
                                    className={cx(`${credentialsInfo?.pickingslipShowRemark}`, {
                                        'active': credentialsInfo?.pickingslipShowRemark
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>

                        {/* Footnote Multiline Text */}
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginTop: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140
                                }}
                            >
                                <Text semiBold>{t("pickingslip_footnote")}</Text>
                            </Box>
                            <Box flex={6}>
                                <InputBase
                                    multiline
                                    rows={3}
                                    sx={{
                                        ml: 2,
                                        flex: 1,
                                        width: '100%',
                                        padding: 2,
                                        borderRadius: '20px',
                                        backgroundColor: colors.grey[100],
                                    }}
                                    value={credentialsInfo?.pickingslipFootnote || ""}
                                    onChange={(e) => handleChange('pickingslipFootnote', e.target.value)}
                                    placeholder={t("pickingslip_footnote_placeholder")}
                                />
                            </Box>
                        </Box>
                        </>
                    )}
                </Dropdown>
                )}

                {!isRelation && (
                <Dropdown title={t("echeck_finalize_message_settings")} subTitle={t("dd_echeck_finalize_message_subtitle")}>
                    <Box sx={{
                        display:"flex",
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            flexDirection:"column"
                        }
                    }}>
                        {/* Show finalize message toggle */}
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginBottom: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140
                                }}
                            >
                                <Text semiBold>{t("show_echeck_finalize_message")}</Text>
                            </Box>
                            <Box flex={6}>
                                <ToggleButtonGroup
                                    color={credentialsInfo?.showEcheckFinalizeMessage ? "green" : "red"}
                                    value={credentialsInfo?.showEcheckFinalizeMessage ? "true" : "false"}
                                    exclusive
                                    onChange={(e,value) => handleChange("showEcheckFinalizeMessage", value === "true" ? true : false)}
                                    aria-label="Show echeck finalize message"
                                    className={cx(`${credentialsInfo?.showEcheckFinalizeMessage}`, {
                                        'active': credentialsInfo?.showEcheckFinalizeMessage
                                    })}
                                    sx={{
                                        background: colors.red[100],
                                        padding:0.5,
                                        borderRadius:5,
                                        transition:"250ms",
                                        "&.active" : {
                                            background:colors.green[100],
                                            transition:"250ms",
                                        },
                                    }}
                                >
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.green[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.red[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="false">
                                        {t('no')}
                                    </ToggleButton>
                                    <ToggleButton
                                        sx={{
                                            padding:0,
                                            paddingX:2,
                                            border:0,
                                            lineHeight:"32px",
                                            textTransform:"unset",
                                            borderRadius:"32px !important",
                                            color:colors.red[400],
                                            transition:"250ms",
                                            "&.Mui-selected,&.Mui-selected:hover" : {
                                                background:colors.green[400],
                                                color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                            }
                                        }}
                                        value="true"
                                    >
                                        {t('yes')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>
                    </Box>

                    {/* Finalize message text - only when enabled */}
                    {credentialsInfo?.showEcheckFinalizeMessage && (
                        <Box flex={1}
                            sx={{
                                display:"flex",
                                gap: 4,
                                justifyContent:"flex-start",
                                marginTop: 2
                            }}
                        >
                            <Box
                                sx={{
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flex:1
                                    },
                                    width: 140
                                }}
                            >
                                <Text semiBold>{t("echeck_finalize_message")}</Text>
                            </Box>
                            <Box flex={6}>
                                <InputBase
                                    multiline
                                    rows={3}
                                    sx={{
                                        ml: 2,
                                        flex: 1,
                                        width: '100%',
                                        padding: 2,
                                        borderRadius: '20px',
                                        backgroundColor: colors.grey[100],
                                    }}
                                    value={credentialsInfo?.echeckFinalizeMessage || ""}
                                    onChange={(e) => handleChange('echeckFinalizeMessage', e.target.value)}
                                    placeholder={t("echeck_finalize_message_placeholder")}
                                />
                            </Box>
                        </Box>
                    )}
                </Dropdown>
                )}

                <SpDesktopFooter>
                    <GridActions
                        hasModifyPermission={hasModifyPermission}
                        isLoading={isLoading}
                        id={credentialsInfo?.id}
                        action={handleSaveClick}
                        syncAction={handleSyncClick}
                        deleteAction={handleDeleteClick}
                    />
                </SpDesktopFooter>
                    <MConfirmDelete
                    open={confirmDeleteModal.open}
                    handleClose={() => confirmDeleteModal.setOpen(false)}
                    data={confirmDeleteModal.data}
                    confirm={confirmDeleteModal.confirm}
                />
            </Box>
    );
}

export default DetailsPanel;
